<template>
  <label :class="variant">
    <span class="block sm:inline">
      <slot />
    </span>
    <select
      :value="modelValue"
      v-bind="{
        ...$attrs,
        onChange: ($event) => {
          let value = +$event.target.value;
          if (isNaN(value)) {
            value = $event.target.value;
          }
          $emit('update:modelValue', value);
        },
      }"
      class="form-select pointer-events-auto h-10 w-full rounded-md border-gpx_gray-600 px-4 py-1 text-base text-gpx_slate-100 shadow-inner outline-none transition-all placeholder:text-gpx_gray-100 focus:border-gpx_terracotta-700 focus:ring-3 focus:ring-gpx_terracotta-200/25"
      :class="selectClass"
    >
      <option value="" disabled selected>Select one</option>
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
        :selected="option.value === modelValue"
      >
        {{ option.label }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'block',
    },
    size: {
      type: String,
      default: 'normal',
    },
    modelValue: {
      type: [Number, String],
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },

  computed: {
    selectClass() {
      return `${this.size}`;
    },
  },
};
</script>

<style scoped>
.sm {
  @apply h-8 text-sm rounded-[3px];
}
</style>
